export default __webpack_public_path__ + "static/media/health-logo.d5be9fc3.svg";